import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetSupportTopic(data = {}) {
  const { enabled = false, config = {}, queryKey = ['support-topic'], categoryId } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const getTopics = () =>
    privateFetch.get(`/v1/admin/support/category/${categoryId}/topic`, { params });

  return useQuery(queryKey, getTopics, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetSupportTopic;
